import { render, staticRenderFns } from "./BrandOrders.vue?vue&type=template&id=5f9a1ac2&lang=pug"
import script from "./BrandOrders.vue?vue&type=script&lang=js"
export * from "./BrandOrders.vue?vue&type=script&lang=js"
import style0 from "./BrandOrders.vue?vue&type=style&index=0&id=5f9a1ac2&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports